export const ADMIN = 'admin';
export const EDITOR = 'editor';
export const PROVIDER = 'provider';
export const CONSUMER = 'consumer';
